export enum TrackingTags {
  nuvempago_cbks_view_document_click = 'nuvempago-cbks-view-document-click',
  pagonube_cbks_document_success = 'pagonube-cbks-document-success',
  pagonube_cbks_document_send_success = 'pagonube-cbks-document-send-success',
  pagonube_cbks_document_error = 'pagonube-cbks-document-error',
  pagonube_cbks_document_send_error = 'pagonube-cbks-document-send-error',
  pagonube_cbks_document_delete = 'pagonube-cbks-document-delete',
}
